import type { ReactNode } from 'react';

type Layout = 'grid' | 'list';

type LayoutViewProps = {
  layout: Layout;
  gridContent: ReactNode;
  listContent: ReactNode;
};

/**
 * Renders `gridContent` when layout is 'grid', `listContent` when layout is 'list'.
 * A thin orchestrator with no styling — place it wherever the view toggle lives.
 */
export function LayoutView({ layout, gridContent, listContent }: LayoutViewProps): ReactNode {
  return layout === 'list' ? listContent : gridContent;
}
